export default "__VITE_ASSET__2tUH2ymR__"